import { QueryKey } from "@tanstack/react-query";

export const migrationQueryKeys = {
  all: () => ["migration"] as QueryKey,
  status: ({ invitationToken }: { invitationToken?: string }) =>
    [...migrationQueryKeys.all(), "status", { invitationToken }] as QueryKey,
  setupIntent: ({ invitationToken }: { invitationToken?: string }) =>
    [...migrationQueryKeys.all(), invitationToken, "setupIntent"] as QueryKey,
};
